// A decimal part at the end of what was typed or pasted: a comma or point
// followed by at most two digits ("12,", "12,5", "1 234,56", "12.50").
const DECIMAL_TAIL = /[.,]\d{0,2}\s*$/;

/**
 * Keeps an amount field to whole kronor however the value arrives – typed,
 * pasted or autofilled – and independent of the browser's locale (the fields
 * are plain text inputs, so neither comma nor point is ever read as a decimal
 * separator). A decimal part is removed and reported, so the field can say
 * why; other commas and points are thousands separators ("1.000.000").
 */
export function wholeKronorInput(
  raw: string,
  { allowNegative = false }: { allowNegative?: boolean } = {}
): { value: string; droppedDecimals: boolean } {
  let value = String(raw ?? '').replace(/[^\d\s,.-]/g, '');
  const droppedDecimals = DECIMAL_TAIL.test(value);
  if (droppedDecimals) value = value.replace(DECIMAL_TAIL, '');
  value = value.replace(/[.,]/g, '');
  const negative = allowNegative && value.trimStart().startsWith('-');
  value = value.replace(/-/g, '');
  return { value: negative ? `-${value.trimStart()}` : value, droppedDecimals };
}
